import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import actions from './actions';
import {get} from 'bukku/shared/ApiService';
import {errorSagaFn, requestSagaPullingFn, successSagaFn} from "../helper";

const successKeys = [
    actions.AUDIT_READ_SUCCESS,
    actions.AUDIT_READ_ALL_SUCCESS,
];
const errorKeys = [
    actions.AUDIT_READ_ERROR,
    actions.AUDIT_READ_ALL_ERROR,
];

const getSuccessMsg = action => {
    switch (action.type) {
        default:
            return null;
    }
};

// Read audits list
function* readAuditsRequest() {
    yield takeEvery(actions.AUDIT_READ_ALL_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ request }) {
                const response = yield call(get, '/reports/audit_trail', request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.AUDIT_READ_ALL_SUCCESS,
                    audits: data.records,
                    pagination: data.paging,
                });
            });
    });
}

// Read audit (by id)
function* readAuditRequest() {
    yield takeEvery(actions.AUDIT_READ_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ id }) {
                const response = yield call(get, `/reports/audit_trail/${id}`, null, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.AUDIT_READ_SUCCESS,
                    audit: data.record,
                });
            });
    });
}

export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),

        fork(readAuditsRequest),
        fork(readAuditRequest),
    ]);
}
